import styled, {css} from "styled-components"

import enableSSo from "./enable_sso.png"
import peopleDirectory from "./people_directory.png"
import customSSO from "./custom_sso.png"

const smallImageCSS = css`
  height: 160px;
  width: 160px;
`

const largeImageCSS = css`
  height: 280px;
  width: 280px;
`

export const EnableSSOImage = styled.img.attrs({
  src: enableSSo,
  alt: "Enable SSO"
})`
  ${smallImageCSS}
`

export const PeopleDirectoryImage = styled.img.attrs({
  src: peopleDirectory,
  alt: "People Directory"
})`
  ${smallImageCSS}
`

export const CustomSSOImage = styled.img.attrs({
  src: customSSO,
  alt: "Custom SSO"
})`
  ${largeImageCSS}
`
